import React, { useRef } from "react";
import { languageHelper } from "../../config/helperFunctions";

function KOT({ data, basicInfo, handlePrint, printer, invoice }) {
  const defaultLang =
    invoice.invoice_lang === "default"
      ? localStorage.getItem("rms-lang") || "text_en"
      : invoice.invoice_lang === "Arabic"
      ? "text_ar"
      : "text_en";
  const kotRef = useRef(null);

  return (
    <div ref={kotRef} className="flex justify-center my-1 px-2">
      <div className="w-full py-4 text-lg-">
        <div className="text-center mb-2">
          <h2 className="font-bold">{languageHelper("KOT", defaultLang)}</h2>
          <p className="font-semibold">
            {languageHelper("Order No", defaultLang)}:{" "}
            {Number(basicInfo?.token_no)}
          </p>
        </div>

        <div className="mb-4 text-center">
          <p>
            <strong>{languageHelper("Invoice No", defaultLang)}:</strong>{" "}
            {basicInfo?.sale_no}
          </p>
          <p>
            <strong>{languageHelper("Date", defaultLang)}:</strong>{" "}
            {basicInfo?.date_time}
          </p>
          <p>
            <strong>{languageHelper("Customer", defaultLang)}:</strong>{" "}
            {basicInfo.customer?.name}
          </p>
          <p>
            <strong>{languageHelper("Order Type", defaultLang)}:</strong>{" "}
            {basicInfo.order_type?.type}
          </p>
        </div>
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-500">
              <th className="text-start">
                {languageHelper("Item", defaultLang)}
              </th>
              <th className="text-start">
                {languageHelper("Qty", defaultLang)}
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((order, index) => (
              <>
                <tr
                  key={index}
                  className={
                    order?.modifiers?.length === 0 &&
                    `border-b-2 ${
                      order?.length - 1 === index && "border-black"
                    }`
                  }
                >
                  <td className="pl-4">
                    <span>
                      {invoice.name_lang === "en" ? (
                        order.name
                      ) : invoice.name_lang === "ar" ? (
                        order.name_arabic
                      ) : (
                        <>
                          {" "}
                          <p> {order.name} </p> <p> {order.name_arabic}</p>
                        </>
                      )}
                    </span>
                  </td>
                  <td>{order.qty}</td>
                </tr>
                {order.food_menu.is_deal === "yes" && (
                  <tr>
                    <td colSpan={5} className="px-8">
                      {order.deal_items &&
                        JSON.parse(order.deal_items)?.map(
                          (deal, index) => (
                            <p key={index}>{`${deal.qty}x ${deal.name}`}</p>
                          )
                        )}
                    </td>
                  </tr>
                )}
                {order.modifiers.map((mod, index) => (
                  <tr
                    key={index * -0.1}
                    className={
                      order?.modifiers?.length === index + 1 &&
                      `border-b-2 ${
                        order?.length - 1 === index && "border-black"
                      }`
                    }
                  >
                    <td className="pl-8">{mod.name}</td>
                    <td>{(mod.price * order.qty).toFixed(2)}</td>
                  </tr>
                ))}
              </>
            ))}
          </tbody>
        </table>

        <div className="mt-4">
          <p className="text-center font-semibold">
            {languageHelper("Total Item(s)", defaultLang)}:{" "}
            {basicInfo?.total_items}
          </p>
        </div>
      </div>
    </div>
  );
}

export default KOT;
